var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-tool-tip-modal" }, [
    _c(
      "button",
      {
        staticClass: "enable-search-tooltip btn",
        attrs: {
          "data-toggle": "infoModal",
          "data-target": "#infoModal",
          "data-whatever": "@mdo",
          "aria-label": "Suchhinweis",
        },
        on: { click: _vm.handleClick },
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "#6b6c6c",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          },
          [
            _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
            _vm._v(" "),
            _c("path", {
              attrs: { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" },
            }),
            _vm._v(" "),
            _c("line", {
              attrs: { x1: "12", y1: "17", x2: "12.01", y2: "17" },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }